export var bid = 'tiktok_promote_rn';
/**
 * 上报域名
 */
export var domain = 'mon-va.byteoversea.com';
export var release = SCM_VERSION;
export var env = 'test';
if (IS_ONLINE) {
    env = 'production';
}
else if (DEV) {
    env = 'development';
}
else {
    env = 'test';
}
